document.addEventListener("DOMContentLoaded", function () {
  function productdesciptiontab() { 
  const button_tabs = document.querySelectorAll(".product-tab_title-label");  
  if (!button_tabs.length) return; 
    button_tabs.forEach(function (tabs) {
    tabs.addEventListener("click", function () { 
      const wrapper = document.querySelector(".product-tab-content");  
      const tab_content = wrapper.querySelectorAll(".product-description-tab-content"); 
      const target_id = this.getAttribute("data-title"); 
      button_tabs.forEach(item => item.classList.remove("is-active"));
      this.classList.add("is-active");  
      tab_content.forEach(item => item.classList.remove("is-active"));
      wrapper.querySelector('#'+target_id).classList.add("is-active");  
    });
  }); 
  
   const read_more_bttn = document.querySelectorAll("button.read_more_bttn");  
   if (read_more_bttn.length) {
       read_more_bttn.forEach(btn=>{
        btn.onclick=()=>{
          const tab = btn.closest(".product-description-tab-content");
          const more = btn.textContent==="Read More";
          tab.classList.toggle("readless-active", more);
          btn.textContent = more ? "Read Less" : "Read More";
        };
      });
    } 

  } 
  productdesciptiontab(); 
   const jdgmreview = document.querySelector(".product-details .jdgm-widget.jdgm-preview-badge"); 
  if (!jdgmreview) return; 
    jdgmreview.addEventListener("click", function () { 
    const reviewtab = document.querySelector('.product-tab_title-label[data-title="desctab-reviews"]');
    reviewtab?.scrollIntoView({ behavior: "smooth", block: "start" });
    (reviewtab instanceof HTMLElement) && reviewtab.click();
  }); 
   
 }); 

// ---------end-product-desciption-tab--------------//
document.addEventListener("DOMContentLoaded", function () {
 function terms_checkout_disabled() {  
      const terms_wrap = document.querySelectorAll(".terms_checkout_disabled");
      if (!terms_wrap.length) return; 
      terms_wrap.forEach(wrap=>{
      const checkbox = wrap.querySelector("input.cart-terms_conditions-input");
      const btn = wrap.querySelector('[name="checkout"].cart--checkout-button');
      const popup = document.querySelector(".cart_terms_conditions_popup"); 
      checkbox?.addEventListener("change", () => {
        const show = checkbox.checked;
        btn?.toggleAttribute("disabled", !show);
        popup.style.display = show ? "block" : "none";
        const no_pickup_input = wrap.querySelector(".cart-no_pickup_product-input");
        if (!no_pickup_input) return; 
        btn.disabled = !no_pickup_input?.checked;
        if (checkbox.checked == false) {
          btn.disabled = true; 
        } 
      }); 
      const close_btn = document.querySelector(".cart_terms_cond_cancle_button"); 
        close_btn?.addEventListener("click", () => {
        popup.style.display = "none";
        checkbox.checked = false;
        btn?.setAttribute("disabled", "disabled");
      });
      const agreebtn = document.querySelector(".cart_terms_cond_agree_button");
        agreebtn?.addEventListener("click", () => {
        popup.style.display = "none"; 
        
      });
 
      const no_pickup_input = wrap.querySelector(".cart-no_pickup_product-input"); 
       no_pickup_input?.addEventListener("change", () => {
         btn.disabled = !no_pickup_input.checked; 
         if (!checkbox) return; 
         btn.disabled = !checkbox?.checked;
         if (no_pickup_input.checked == false) {
          btn.disabled = true; 
         }
      });
    }); 

 } terms_checkout_disabled();

 
  function buyrentals_button() { 
  const button_radio = document.querySelectorAll(".form_radio-rentals-option-input");  
  if (!button_radio.length) return; 
    button_radio.forEach(function (radio) {
      radio.addEventListener("change", function () { 
      const rentals_button = document.querySelector(".product--rentals_buttons"); 
      const radio_val = radio.getAttribute('value');  
      if (radio_val === "Yes" && radio.checked ) {
        rentals_button.classList.add("is_active");
         const buy_buttons = document.querySelector('.product-form--block[data-block-type="buy-buttons"]');  
         buy_buttons.style.display = "none"; 
       }  else { 
         rentals_button.classList.remove("is_active"); 
          const buy_buttons = document.querySelector('.product-form--block[data-block-type="buy-buttons"]');  
         buy_buttons.style.display = "block"; 
        }
    });
  }); 
 } buyrentals_button(); 

// ------------------//

function additional_metafield_price() { 
  const dropdown_option = document.querySelectorAll('.product-options-metafield li.disclosure--option[aria-current]');     
  if (!dropdown_option.length) return;  
      dropdown_option.forEach((list) => {  
      list.addEventListener("click", function () {
        const value_current = this.getAttribute('data-value');
        if (/\bno\b/i.test(value_current)) {
          const this_closest = this.closest('.disclosure--main');
          setTimeout(() => {
            this_closest.querySelector('input.metafield_product-selectoption')?.setAttribute('value', '');
            this_closest.querySelector('input.metafield_product-selectoption')?.setAttribute('data-option-value-id', '');
          }, 200);
        }


      var randno = document.querySelector('input.rno_properties');
      if (randno) {
        const randomNumber = Math.floor(100000 + Math.random() * 900000); 
          randno.setAttribute('value', randomNumber)
          // console.log('randomNumber = '+ randomNumber); 
      }
    

      //  const rent_plan = this.closest(".product_rent_plan-options");
      //  if (rent_plan) { 
      //      let subsc_price = parseFloat(this.getAttribute('data-product-price').replace(',',''));
      //       const span = rent_plan.querySelector('.subscribe_price');
      //         span.textContent = `$${subsc_price.toLocaleString('en-US', {
      //         minimumFractionDigits: 2,
      //         maximumFractionDigits: 2
      //       })} every month`;  
      //  }
   


    });
 });

//  const disclosure_option = document.querySelectorAll('product-options-element .disclosure--form li.disclosure--option');     
//   if (disclosure_option.length) { 
//       disclosure_option.forEach((list) => {  
//       list.addEventListener("click", function () {    
//         let current_optiontitle = list.getAttribute('data-variant-title') ;   
//           const mattress = document.querySelectorAll('ul[data-label-type="mattress"] li[data-option-name="mattress"]');     
//           if (mattress.length) { 
//             alert(current_optiontitle);
//             // console.log('current_optiontitle:', current_optiontitle);   
//               mattress.forEach((matlist) => {
//             let mat_id = matlist.getAttribute("data-option-value-id");
//             let mat_optiontitle = matlist.getAttribute("data-item-variant-title");
//              console.log('current_optiontitle:', current_optiontitle);  
//             // matlist.classList.add("hidden"); 
//             if (mat_optiontitle == current_optiontitle){
//                 // console.log('mat_optiontitle:', mat_optiontitle);  
//                 //  matlist.classList.remove("hidden"); 
//             }
//             else {
//             // console.log('current_optiontitle:', current_optiontitle); 
//             //  matlist.classList.add("hidden"); 
//             }
//           });  
//          }
//       });
//       }); 
//     }

}
additional_metafield_price();

//---------price_function_glitching----------//
function price_function_glitching () { 
    let additional_price = 0;  
    const pricecontainer = document.querySelector('[data-block-type="price"] .product-price--wrapper');
    if (!pricecontainer) return; 
      const meta_op_price = document.querySelectorAll('.product-options-metafield li.disclosure--option[aria-current="true"]:not([style="display: none;"])'); 
      if (meta_op_price.length){   
          meta_op_price.forEach((input) => {  
          const price = parseFloat(input.getAttribute('data-product-price')) || 0;
          if (price)  
          additional_price += price;  
        }); 
     let main_price, price_original = pricecontainer?.querySelector(".product-price--original"),
       productoptionselement = document.querySelector('product-options-element');
     if (productoptionselement){
     main_price = parseFloat(productoptionselement?.getAttribute('data-option-value-price').replace('$','').replace(',',''));
     } else {
     main_price = parseFloat(price_original?.getAttribute('data-item-price').replace('$','').replace(',',''));
     }
       if (additional_price > 0) {
      main_price = main_price + additional_price;
      price_original.innerHTML = `$${main_price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
      } else {   
       if(main_price) { 
      price_original.innerHTML = `$${main_price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
       }
     } 
    }
 }price_function_glitching ();

//-------------------//
  function serviceplans_field() { 
  const button_checkbox = document.querySelector("input#personalization-add-on-services");  
  if (!button_checkbox) return;  
      button_checkbox.addEventListener("change", function () {
        let additional_price = 0; 
        const service_plans = document.querySelector(".product_service_plan-options"); 
        const service_list = service_plans.querySelector('li.disclosure--option[aria-current]:first-child'); 
        if (button_checkbox.checked) {
         service_plans.classList.remove("hidden");    
         service_plans.querySelector('input.metafield_product-selectoption')?.setAttribute('value', service_list?.getAttribute('data-value'));
         service_plans.querySelector('input.metafield_product-selectoption')?.setAttribute('data-option-value-id', service_list?.getAttribute('data-option-value-id'));
         service_list.setAttribute('aria-current', true);
         
        } else {
        service_plans.classList.add("hidden");  
        service_plans.querySelector('input.metafield_product-selectoption')?.setAttribute('value', '');
        service_plans.querySelector('input.metafield_product-selectoption')?.setAttribute('data-option-value-id', ''); 
        service_list.setAttribute('aria-current', false);  
        } 
         setTimeout(() => { 
               price_function_glitching () ; 
          }, 800); 
    }); 
 } serviceplans_field(); 
 
 //-------------------//
  function rent_button_link() { 
  const rent_button = document.querySelectorAll("input.form_radio-rent-option-input");  
  if (rent_button.length){
    rent_button.forEach((input) => {  
      input.addEventListener("change", function () {
        const rent_plan = document.querySelector(".product_rent_plan-options");  
        const service_list = rent_plan.querySelector('li.disclosure--option[aria-current]:first-child'); 
        if (input.value == 'Rent to Own') { 
         document.querySelectorAll('.renttobtn').forEach(btn => btn.style.display = "block");
         document.querySelectorAll('.renttobtn_without').forEach(btn => btn.style.display = "none"); 
         rent_plan.classList.remove("hidden");   
         rent_plan.querySelector('input.metafield_product-selectoption')?.setAttribute('value', service_list.getAttribute('data-value'));
         rent_plan.querySelector('input.metafield_product-selectoption')?.setAttribute('data-option-value-id', service_list.getAttribute('data-option-value-id'));
          service_list.setAttribute('aria-current', true);   
           const service_list_t = rent_plan.querySelector('li.disclosure--option[aria-current="true"]');
           let subsc_price = parseFloat(service_list_t.getAttribute('data-product-price').replace(',',''));
           if (subsc_price) {
           const span = document.createElement("span");
            span.classList.add("subscribe_price", "product-price");
            span.textContent = `$${subsc_price.toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })} every month`; 
             rent_plan.appendChild(span);  
             
             const current_option = rent_plan.querySelector('.disclosure--current-option');
             current_option.textContent = service_list_t.getAttribute('data-value');
          }
          
           document.querySelector('.rent-info-bullets-points')?.classList.add('info-active');
            
        } else {
         document.querySelectorAll('.renttobtn').forEach(btn => btn.style.display = "none");
         document.querySelectorAll('.renttobtn_without').forEach(btn => btn.style.display = "block");
        rent_plan.classList.add("hidden");  
        rent_plan.querySelector('input.metafield_product-selectoption')?.setAttribute('value', '');
        rent_plan.querySelector('input.metafield_product-selectoption')?.setAttribute('data-option-value-id', ''); 
        const rentCheckbox = rent_plan?.querySelector('input.form_radio-rent-and-rent-to-own-input:first-child');
        service_list.setAttribute('aria-current', false); 
        if (rentCheckbox) rentCheckbox.checked = true;
        const rent_plan_list = rent_plan.querySelector(".disclosure--main");
        rent_plan_list.classList.remove("hidden"); 
        
        const oldSubPrice = rent_plan.querySelector('.subscribe_price');
          if (oldSubPrice) oldSubPrice.remove(); 

          document.querySelector('.rent-info-bullets-points')?.classList.remove('info-active');
        }  
          setTimeout(() => { 
               price_function_glitching () ; 
          }, 500); 
      });  
   }); 
  }

 const rent_check = document.querySelectorAll("input.form_radio-rent-and-rent-to-own-input");  
  if (rent_check.length){
    rent_check.forEach((input) => {  
      input.addEventListener("change", function () {
        const rent_plan = input.closest(".product_rent_plan-options"); 
        const rent_plan_list = rent_plan.querySelector(".disclosure--main"); 
         const service_list = rent_plan_list.querySelector('li.disclosure--option[aria-current]:first-child');  
           
        if (input.value == 'Rent') { 
            rent_plan_list.classList.add("hidden");  
            rent_plan_list.querySelector('input.metafield_product-selectoption')?.setAttribute('value', '');
            rent_plan_list.querySelector('input.metafield_product-selectoption')?.setAttribute('data-option-value-id', '');  
            service_list.setAttribute('aria-current', false); 
           
            const oldSubPrice = rent_plan.querySelector('.subscribe_price');
            if (oldSubPrice) oldSubPrice.remove(); 
            setTimeout(() => { 
               price_function_glitching (); 
          }, 500); 


          } else {
             rent_plan_list.classList.remove("hidden"); 
             service_list.setAttribute('aria-current', true); 
             rent_plan_list.querySelector('input.metafield_product-selectoption')?.setAttribute('value', service_list.getAttribute('data-value'));
             rent_plan_list.querySelector('input.metafield_product-selectoption')?.setAttribute('data-option-value-id', service_list.getAttribute('data-option-value-id'));
           
           setTimeout(() => {    
           const service_list_t = rent_plan.querySelector('li.disclosure--option[aria-current="true"]');
           let subsc_price = parseFloat(service_list_t.getAttribute('data-product-price').replace(',',''));
           const span = document.createElement("span");
            span.classList.add("subscribe_price", "product-price");
            span.textContent = `$${subsc_price.toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })} every month`; 
             rent_plan.appendChild(span); 
              const current_option = rent_plan.querySelector('.disclosure--current-option');
             current_option.textContent = service_list_t.getAttribute('data-value');

            price_function_glitching (); 
          }, 800); 
        }
        });  
   }); 
  }
  //  const rentinfocircle = document.querySelector('span.rent-info-circle');
  //  if (rentinfocircle) {  
  //   rentinfocircle.addEventListener("click", function () {  
  //     const rentinfobullets = document.querySelector('.rent-info-bullets-points'); 
  //  if (rentinfobullets) {
  //     rentinfobullets.classList.toggle("info-active");
  //    }
  //   }); 
  //  }

 } rent_button_link(); 


  const chatbutton = document.querySelectorAll('a.section-blocks--button[href="#chat-with-us"]');  
  if (!chatbutton.length) return; 
    chatbutton.forEach(function (chat) {
    chat.addEventListener("click", function () {  
      if (window.tidioChatApi) {
       window.tidioChatApi.open();
      } else {
      document.addEventListener("tidioChat-ready", function () {
        window.tidioChatApi.open();
      });
    }
    });
  });
});
// ---------------------------------------------------------------------------
// Accessibility (WCAG 2.2 AA, SC 4.1.2) — header overlap state
//
// theme.js signals "primary menu is too wide, collapse into the drawer" by
// setting aria-expanded on <header-element>. aria-expanded is only valid on
// widget roles, so automated checkers report it (axe: aria-allowed-attr). The
// state is mirrored onto data-overlap-active instead and the aria attribute is
// dropped; custom.css carries the matching selectors, so behaviour is the same.
// ---------------------------------------------------------------------------
(function () {
  function mirrorOverlapState(el) {
    if (!el || !el.hasAttribute("aria-expanded")) return;
    el.setAttribute("data-overlap-active", el.getAttribute("aria-expanded"));
    el.removeAttribute("aria-expanded");
  }

  function patchHeaderElement(HeaderClass) {
    var proto = HeaderClass && HeaderClass.prototype;
    if (!proto || proto.__itgOverlapPatched || typeof proto.enableOverlap !== "function") return;
    var originalEnableOverlap = proto.enableOverlap;
    proto.enableOverlap = function (state) {
      var result = originalEnableOverlap.apply(this, arguments);
      this.setAttribute("data-overlap-active", String(!!state));
      this.removeAttribute("aria-expanded");
      return result;
    };
    proto.__itgOverlapPatched = true;
    document.querySelectorAll("header-element").forEach(mirrorOverlapState);
  }

  if (window.customElements && typeof customElements.whenDefined === "function") {
    customElements.whenDefined("header-element").then(function () {
      patchHeaderElement(customElements.get("header-element"));
    });
  }
})();

// ---------------------------------------------------------------------------
// Accessibility (WCAG 2.2 AA, SC 4.1.3) — predictive search status messages
//
// The search input used to be marked role="combobox" with a listbox popup and
// list autocomplete, none of which the theme implements (results are a grid of
// product links and aria-expanded never changed). Those attributes were removed
// from snippets/main-search.liquid. In their place, each time theme.js swaps the
// results markup, a short message is written to the sr-only role="status"
// element next to the input so screen-reader users hear what happened.
// ---------------------------------------------------------------------------
(function () {
  function buildMessage(root, query) {
    var results = root.querySelector(".search--results");
    if (!results) return "";
    var feedback = results.querySelector(".predictive-search--feedback");
    if (feedback) return feedback.textContent.trim();
    var count = results.querySelectorAll(".product-card--root").length;
    if (count) {
      return count + (count === 1 ? " product" : " products") + " shown for “" + query + "”. Press Tab to move through the results.";
    }
    return "Results updated for “" + query + "”.";
  }

  function announce(root) {
    var input = root.querySelector(".search--textbox");
    var status = root.querySelector("[role=\"status\"]");
    if (!input || !status) return;
    var query = input.value.trim();
    if (!query) { status.textContent = ""; return; }
    var message = buildMessage(root, query);
    if (status.textContent === message) return;
    // Clear first so an identical-looking update is still announced.
    status.textContent = "";
    setTimeout(function () { status.textContent = message; }, 50);
  }

  function watch(root) {
    var results = root.querySelector(".search--results");
    if (!results || root.__itgStatusWatched) return;
    root.__itgStatusWatched = true;
    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () { announce(root); }, 400);
    }).observe(results, { childList: true });
  }

  function init() {
    document.querySelectorAll("predictive-search-element").forEach(watch);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

// ---------------------------------------------------------------------------
// Accessibility (WCAG 2.2 AA, SC 1.3.1) — landmark names
//
// Shopify wraps the announcement section in <aside>, a "complementary" landmark,
// and does not allow attributes on that wrapper. It is named here so a
// screen-reader landmark list reads "Announcements" instead of an anonymous
// complementary region.
// ---------------------------------------------------------------------------
(function () {
  function nameLandmarks() {
    document.querySelectorAll("aside.section--announcement:not([aria-label])").forEach(function (el) {
      el.setAttribute("aria-label", "Announcements");
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", nameLandmarks);
  } else {
    nameLandmarks();
  }
  document.addEventListener("shopify:section:load", nameLandmarks);
})();
